import { NgModule } from '@angular/core'

import { SharedModule } from '../shared/shared.module'
import { VideoPlayerModule } from '../shared/video-player/video-player.module'
import { FloFilmsComponent } from './films.component'
import { FloFilmsRoutingModule } from './films-routing.module'
import { IsoStringToDatePipeModule } from '../libs/iso-string-to-date-pipe/iso-string-to-date-pipe.module'

@NgModule({
  imports: [FloFilmsRoutingModule, SharedModule, VideoPlayerModule, IsoStringToDatePipeModule],
  exports: [FloFilmsComponent],
  declarations: [FloFilmsComponent]
})
export class FloFilmsModule {}
